var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLcCgrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7164_39420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 11H9C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10V3.5L7.5 1H3C2.73478 1 2.48043 1.10536 2.29289 1.29289C2.10536 1.48043 2 1.73478 2 2V4M7 1V3C7 3.26522 7.10536 3.51957 7.29289 3.70711C7.48043 3.89464 7.73478 4 8 4H10M3.5 8.5V11M3.5 8.5L5.85002 7.09998M3.5 8.5L1.15002 7.09998M1.50004 6.55002C1.34595 6.63896 1.21838 6.7674 1.13049 6.92209C1.04259 7.07678 0.997564 7.25212 1.00004 7.43002V9.05002C0.99425 9.22812 1.03616 9.40454 1.12143 9.56102C1.2067 9.71749 1.33223 9.84834 1.48504 9.94002L3.00004 10.85C3.15338 10.9414 3.32838 10.99 3.50686 10.9909C3.68534 10.9917 3.8608 10.9448 4.01504 10.855L5.50004 9.95002C5.65413 9.86108 5.7817 9.73264 5.86959 9.57795C5.95749 9.42326 6.00252 9.24792 6.00004 9.07002V7.45002C6.00583 7.27191 5.96392 7.09549 5.87865 6.93902C5.79338 6.78254 5.66785 6.6517 5.51504 6.56002L4.00004 5.65002C3.8467 5.55868 3.6717 5.51005 3.49322 5.50917C3.31474 5.50829 3.13927 5.55519 2.98504 5.64502L1.50004 6.55002Z",
    stroke: "#525062",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7164_39420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcCgrey);
export default __webpack_public_path__ + "static/media/LCCgrey.8bef40f977be72aa79c58eb19732a4b7.svg";
export { ForwardRef as ReactComponent };